import axios from 'axios';
import {backendHost} from '../../config';

export const getPromoUsersCount = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/players/promo`, {params});
};